import ContractRegistrationService from '../services/contract_registration.service';


const getDefaultState = () => {
  return {
    contract_code: "",
    edi: "",
    phg: "",
    vcj_origin: "",
    vcj_sales: "",
    date: null,
    consective_no: ""
  }
}

export const contractRegistrationAdd = {
  namespaced: true,
  state: {
    stateData: getDefaultState()
  },
  actions: {
    getLatestCode({commit}) {
      return ContractRegistrationService.getLatestCode().then(
        (response) => {
          commit('getSuccess', response);
          return Promise.resolve(response);
        },
        error => {
          commit('getFailure');
          return Promise.reject(error);
        }
      );
    },
    saveCode({commit}, data) {
      return ContractRegistrationService.saveCode(data).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          commit("saveFailure");
          return Promise.reject(error);
        }
      );
    },
    resetState({commit}) {
      commit("resetState");
    },
    getContractRegCode({commit}, id) {
      return ContractRegistrationService.getContractRegCode(id).then(
        (response) => {
          commit('getContractRegSuccess', response);
          return Promise.resolve(response);
        },
        error => {
          commit('getContractRegFailure');
          return Promise.reject(error);
        }
      );
    },
    updateCode({commit}, data) {
      console.log("call updateCode module");
      return ContractRegistrationService.updateCode(data).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          commit("saveFailure");
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    getSuccess(state, response) {
      state.stateData.consective_no = ContractRegistrationService.initConsectiveNo(response);
    },
    getFailure(state) {
      state.stateData.consective_no = ""
    },
    resetState (state) {
      console.log("run resetState");
      Object.assign(state.stateData, getDefaultState())
    },
    getContractRegSuccess(state, response) {
      state.stateData.id = response.id;
      state.stateData.contract_code = response.contract_code;
      state.stateData.edi = response.edi;
      state.stateData.phg = response.phg;
      state.stateData.vcj_origin = response.vcj_origin;
      state.stateData.vcj_sales = response.vcj_sales;
      state.stateData.date = response.date;
      state.stateData.consective_no = response.consective_no;
    },
    getContractRegFailure(state) {
      this.resetState(state);
    },
  },
  getters: {

  }
}